// Run the segment-assembly stitch, retrying once if it produces no usable audio.
//
// stitchSegmentsStreaming returns { mp3DataUrl, decodedCount, failedCount } and
// sets mp3DataUrl to null when nothing decoded OR the MP3 encoder died mid-stream
// (a transient failure where the audio actually decoded fine). Retrying the whole
// stitch once recovers that transient case before the caller fails loud. A
// persistent failure returns the last result unchanged so the caller's existing
// `!mp3DataUrl` throw + requeue still fires, with decodedCount/failedCount intact.
//
// `stitchOnce` is an async thunk performing one full stitch attempt. Thrown errors
// propagate (the caller's outer handler already routes a thrown stitch to its
// retry/error path) — only a falsy mp3DataUrl triggers the in-function retry.
export async function stitchWithRetry(stitchOnce, { attempts = 2 } = {}) {
  let result = { mp3DataUrl: null, decodedCount: 0, failedCount: 0 };
  for (let attempt = 0; attempt < attempts; attempt++) {
    result = await stitchOnce();
    if (result && result.mp3DataUrl) return result;
  }
  return result;
}
